/* eslint eqeqeq: off */
import React from "react";
import './index.css';
import Modal, {ModalAction, ModalContent, ModalControls} from "../../../Components/Modal";
import Button from "../../../Components/Control/Button";
import Input from "../../../Components/Control/Input";
import Select from "../../../Components/Control/Select";
import {connect} from "react-redux";
import moment from "jalali-moment";
import Date from "../../../Components/Control/Date";
import Resource from "../../../Resource";
import PropTypes from 'prop-types';
import Separator from "../../../Components/Control/Separator";
import Label from "../../../Components/Control/Label";
import Radio from "../../../Components/Control/Radio";
import Check from "../../../Components/Control/Check";
import {updateBase} from "../../../Redux/Actions/base";
import {Tool} from "../../../App";
import ValidationSpot from "../../../Components/Control/ValidationSpot";
import ModalPrint from "../ModalPrint";
import {printerTemplate} from "../../../Printer";
import Notif from "../../../Components/Notif";
import Patient from "../../../Server/Patient";
import {SectionEmerRequest} from '../../../Server/EmerRequest';
import InputButton from '../../../Components/Control/InputButton';
import MyComponent from '../../../Components/MyComponent';

class ModalEmerRequest extends MyComponent {
    constructor(props) {
        super(props);
        props.refer.current = this;

        this.state = {
            error: null,
            loading: null,
            provinces: [
                {id: '', text: '...', cities: []},
                ...props.base.provinceCities.map(item => {
                    return {
                        id: item.provinceId, text: item.provinceName, cities: (item.cities || []).map(item => {
                            return {id: item.cityId, text: item.cityName};
                        })
                    };
                })
            ],
            sections: [
                {id: '', text: '...'},
                ...props.base.hospitalSections.map(item => {
                    return {id: item.sectionId, text: item.sectionName};
                })
            ],
            fields: {}
        };

        this.ref = {
            modal: React.createRef(),
            modalPrint: React.createRef(),
            patientFirstName: React.createRef(),
            patientLastName: React.createRef(),
            patientFatherName: React.createRef(),
            patientBirthDate: React.createRef(),
            patientNationalCode: React.createRef(),
            patientGenderId: React.createRef(),
            patientProvinceId: React.createRef(),
            patientCityId: React.createRef(),
            sectionId: React.createRef(),
            patientFileCode: React.createRef(),
            bloodSampleSend: React.createRef(),
            emergencyRequestReasonStr: React.createRef(),
            bloodBankInform: React.createRef(),
            needCrossMatch: React.createRef(),
            docterId: React.createRef(),
            withoutCrossMatch: React.createRef(),
            withoutRH: React.createRef(),
            rbcCount: React.createRef(),
            products: React.createRef(),
            wbCount: React.createRef(),
            insert: React.createRef(),
            update: React.createRef(),
            printLabel: React.createRef(),
        };
    }

    static defaultProps = {
        refer: {current: null},
        onClose: _ => null,
        onSuccess: _ => null
    };

    static propTypes = {
        refer: PropTypes.object,
        onClose: PropTypes.func,
        onSuccess: PropTypes.func
    };

    validations = {
        patientFirstName: x => Boolean(!this.state.fields?.patientFileCode || x) || 'نام بیمار نمی‌تواند خالی باشد.',
        patientLastName: x => Boolean(!this.state.fields?.patientFileCode || x) || 'نام خانوادگی بیمار نمی‌تواند خالی باشد.',
        patientFatherName: x => Boolean(!this.state.fields?.patientFileCode || x) || 'نام پدر بیمار نمی‌تواند خالی باشد.',
        patientBirthDate: x => Boolean(!this.state.fields?.patientFileCode || x) || 'تاریخ تولد نمی‌تواند خالی باشد.',
        patientGenderId: x => Boolean(!this.state.fields?.patientFileCode || x) || 'جنسیت بیمار انتخاب نشده است.',
        patientProvinceId: x => true || Boolean(!this.state.fields?.patientFileCode || x[0]?.id) || 'استان انتخاب نشده است.',
        patientCityId: x => true || Boolean(!this.state.fields?.patientFileCode || x[0]?.id) || 'شهر انتخاب نشده است.',
        sectionId: x => Boolean(x?.[0]?.id) || 'بخش انتخاب نشده است.',
        patientFileCode: x => Boolean(x) || 'شماره پرونده بیمار وارد نشده است.',
        bloodSampleSend: x => x === false || x === true || 'وضعیت نمونه خون بیمار انتخاب نشده است.',
        emergencyRequestReasonStr: x => Boolean(x) || 'علت درخواست خون اورژانسی وارد نشده است.',
        bloodBankInform: x => x === false || x === true || 'وضعیت مطلع نمودن بانک خون انتخاب نشده است.',
        needCrossMatch: x => x === false || x === true || 'وضعیت نیاز به خون انتخاب نشده است.',
        docterId: x => Boolean(x?.[0]?.id) || 'نام پزشک انتخاب نشده است.',
        // withoutCrossMatch: x => Boolean(x) || '',
        // withoutRH: x => Boolean(x) || '',
        products: fields => {
            return Boolean(fields.rbcCount) ||
                Boolean(fields.wbCount) ||
                'فرآورده انتخاب نشده است.';
        },
        rbcCount: x => x === '' || x === undefined || x === false || x > 0 || 'تعداد وارد نشده است.',
        wbCount: x => x === '' || x === undefined || x === false || x > 0 || 'تعداد وارد نشده است.'
    };

    componentDidMount() {

    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        const {state, props} = this;

        return state.action !== nextState.action ||
            state.error !== nextState.error ||
            state.loading !== nextState.loading ||
            state.fields !== nextState.fields ||
            state.patientFileInfo !== nextState.patientFileInfo ||
            props.base.sectionEmerRequestFormPrintView !== nextProps.base.sectionEmerRequestFormPrintView ||
            props.base.normRequestFormPrintOnSubmit !== nextProps.base.normRequestFormPrintOnSubmit;
    }

    render() {
        const {state, props, ref} = this;
        const cities = [{id: '', text: '...'}];
        const doctors = [
            {id: '', text: '...'},
            ...props.base.doctors
        ];

        state.fields?.patientProvinceId && cities.push(...(state.fields?.patientProvinceId[0]?.cities || []));

        return <React.Fragment>
            <Modal ref={ref.modal}
                   name={'ModalEmerRequest'}
                   size={'large'}
                   title={'فرم درخواست اورژانسی از بانک خون'}
                   required={true}
                   error={this.state.error}
                   loading={this.state.loading}
                   onClose={this.props.onClose}>
                <ModalContent>
                    <div onDoubleClick={this.autoFillClickHandler.bind(this)}>
                        {props.base.sectionEmerRequestFormPrintView ?
                            <table>
                                <tbody>
                                <tr style={{backgroundColor: '#a1d6ee'}}>
                                    <td colSpan={10}>
                                        <div className={'dis-f'}>
                                            <div className={'flex ali-c'} style={{fontSize: 13, fontWeight: 500}}>
                                                درخواست خون و فرآورده‌های خونی به طور اورژانسی (تهیه کمتر از 30 دقیقه)<br/>
                                                مسئول تکمیل فرم: 1- پزشک معالج 2- پرسنل بانک خون
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={10} style={{backgroundColor: "#009fda", padding: '5px 0'}}><Label style={{color: 'white'}} align={'center'}>این قسمت توسط پزشک معالج تکمیل شود.</Label></td>
                                </tr>
                                <tr>
                                    <td><Input ref={ref.patientFirstName} className={'pad-4'} label={'نام'} validation={this.validations.patientFirstName} readOnly={!state.isNewPatient} value={state.fields?.patientFirstName} onChange={this.setField.bind(this, 'patientFirstName')}/></td>
                                    <td colSpan={2}><Input ref={ref.patientLastName} className={'pad-4'} label={'نام خانوادگی'} validation={this.validations.patientLastName} readOnly={!state.isNewPatient} value={state.fields?.patientLastName} onChange={this.setField.bind(this, 'patientLastName')}/></td>
                                    <td><Input ref={ref.patientFatherName} className={'pad-4'} label={'نام پدر'} validation={this.validations.patientFatherName} readOnly={!state.isNewPatient} value={state.fields?.patientFatherName} onChange={this.setField.bind(this, 'patientFatherName')}/></td>
                                    <td colSpan={2}><Date ref={ref.patientBirthDate} className={'pad-4'} label={'تاریخ تولد'} max={moment().endOf('jday')} validation={this.validations.patientBirthDate} readOnly={!state.isNewPatient} value={state.fields?.patientBirthDate} onChange={this.setField.bind(this, 'patientBirthDate')}/></td>
                                    <td colSpan={2}><Input ref={ref.patientNationalCode} align={"center"} direction={"ltr"} className={'pad-4'} type={"number"} label={'کدملی'} readOnly={!state.isNewPatient} value={state.fields?.patientNationalCode} onChange={this.setField.bind(this, 'patientNationalCode')}/></td>
                                    <td colSpan={2}>
                                        <ValidationSpot ref={ref.patientGenderId} label={'جنسیت'} className={'dis-f pad-4'} style={{flexDirection: 'column'}} validation={this.validations.patientGenderId} readOnly={!state.isNewPatient}>
                                            <Label size={'small'}>جنسیت</Label>
                                            <div className={'dis-f'}>
                                                <div className={'pad-h-4'}>
                                                    <Radio label={'مرد'} name={'patientGenderId'} checked={state.fields?.patientGenderId == 1} onClick={this.setField.bind(this, 'patientGenderId', 1)}/>
                                                </div>
                                                <div className={'pad-h-4'}>
                                                    <Radio label={'زن'} name={'patientGenderId'} checked={state.fields?.patientGenderId == 2} onClick={this.setField.bind(this, 'patientGenderId', 2)}/>
                                                </div>
                                            </div>
                                        </ValidationSpot>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={2}><Select ref={ref.patientProvinceId} className={'pad-4'} label={'استان'} options={state.provinces} validation={this.validations.patientProvinceId} readOnly={!state.isNewPatient} value={state.fields?.patientProvinceId} onChange={this.setField.bind(this, 'patientProvinceId')}/></td>
                                    <td colSpan={2}><Select ref={ref.patientCityId} className={'pad-4'} label={'شهر'} options={cities} validation={this.validations.patientCityId} readOnly={!state.isNewPatient} value={state.fields?.patientCityId} onChange={this.setField.bind(this, 'patientCityId')}/></td>
                                    <td colSpan={2}><Input className={'pad-4'} label={'بیمارستان'} readOnly={true} value={props.user?.hospitalFullName}/></td>
                                    <td colSpan={2}><Select ref={ref.sectionId} className={'pad-4'} label={'بخش'} options={state.sections} validation={this.validations.sectionId} value={state.fields?.sectionId} onChange={this.setField.bind(this, 'sectionId')}/></td>
                                    {/*<td colSpan={2}><Input ref={ref.patientFileCode} className={'pad-4'} label={'شماره پرونده'} validation={this.validations.patientFileCode} value={state.fields?.patientFileCode} onChange={this.setFiel.bind(this, 'patientFileCode')} onBlur={this.patientFileCodeSubmitHandler.bind(this)} onEnter={this.patientFileCodeSubmitHandler.bind(this)}/></td>*/}
                                    <td colSpan={2}><InputButton ref={ref.patientFileCode} className={'pad-4'} label={'شماره پرونده'} validation={this.validations.patientFileCode} value={state.fields?.patientFileCode} onChange={this.setField.bind(this, 'patientFileCode')} onEnter={this.patientFileCodeSubmitHandler.bind(this)} buttonTitle={'جستجو'} onButtonClick={this.patientFileCodeSubmitHandler.bind(this)}/></td>
                                </tr>
                                <tr>
                                    <td colSpan={10}>
                                        <Label style={{backgroundColor: '#a1d6ee', padding: '5px 10px'}} className={'flex'}>نمونه خون بیمار :</Label>
                                        <ValidationSpot ref={this.ref.bloodSampleSend} className="dis-f" validation={this.validations.bloodSampleSend} label={'نمونه خون بیمار'}>
                                            <div className="dis-f fb-20">
                                                <Radio label={'تهیه و قبل از تزریق ارسال شد.'} name={'bloodSampleSend'} checked={state.fields?.bloodSampleSend === true} onClick={this.setField.bind(this, 'bloodSampleSend', true)}/>
                                            </div>
                                            <div className="dis-f fb-20">
                                                <Radio label={'ارسال نشد.'} name={'bloodSampleSend'} checked={state.fields?.bloodSampleSend === false} onClick={this.setField.bind(this, 'bloodSampleSend', false)}/>
                                            </div>
                                        </ValidationSpot>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={10}>
                                        <div className={'dis-f'}>
                                            <Input ref={this.ref.emergencyRequestReasonStr} type={'text'} name={'emergencyRequestReasonStr'} className={'fb-20 pad-4'} label={'علت درخواست خون اورژانس'} value={state.fields?.emergencyRequestReasonStr} validation={this.validations.emergencyRequestReasonStr} onChange={this.setField.bind(this, 'emergencyRequestReasonStr')}/>
                                            <Input type={'text'} className={'fb-10 pad-4'} readOnly={true} label={'تاریخ درخواست'} value={moment().format('jYYYY-jMM-jDD')}/>
                                            <Input type={'text'} className={'fb-10 pad-4'} readOnly={true} label={'ساعت درخواست'} value={moment().format('HH:mm')}/>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={10}>
                                        <ValidationSpot ref={this.ref.bloodBankInform} className="dis-f" label={'نحوه اطلاع بانک خون'} validation={this.validations.bloodBankInform}>
                                            <Label style={{padding: '5px 10px'}} className={'flex'}>مطلع نمودن بانک خون :</Label>
                                            <div className="dis-f fb-20">
                                                <Radio label={'درخواست تلفنی از بانک خون و سپس تکمیل فرم'} name={'bloodBankInform'} checked={state.fields?.bloodBankInform === false} onClick={this.setField.bind(this, 'bloodBankInform', false)}/>
                                            </div>
                                            <div className="dis-f fb-20">
                                                <Radio label={'تکمیل و ارسال فرم به بانک خون'} name={'bloodBankInform'} checked={state.fields?.bloodBankInform === true} onClick={this.setField.bind(this, 'bloodBankInform', true)}/>
                                            </div>
                                        </ValidationSpot>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={10}>
                                        <div className="dis-f">
                                            <Label style={{backgroundColor: '#a1d6ee', padding: '5px 10px'}} className={'flex'}>زمان نیاز به خون:</Label>
                                            <div className="dis-f fb-20">
                                                <ValidationSpot ref={this.ref.needCrossMatch} className={'dis-f fb-20'} validation={this.validations.needCrossMatch}>
                                                    <Radio className={'fb-20'} label={'بلافاصله پس از درخواست پزشک (بدون کراسمچ)'} name={'needCrossMatch'} checked={state.fields?.needCrossMatch === false} onClick={this.setField.bind(this, 'needCrossMatch', false)}/>
                                                    <Radio className={'fb-20'} label={'30 دقیقه پس از دریافت درخواست (تعیین ABO، Rh و کراسمچ)'} name={'needCrossMatch'} checked={state.fields?.needCrossMatch} onClick={this.setField.bind(this, 'needCrossMatch', true)}/>
                                                </ValidationSpot>
                                                <ValidationSpot ref={this.ref.docterId} label={'متن درخواست اورژانسی'} validation={this.validations.docterId}>
                                                    <Label className={'fb-20'} style={{display: 'flex', flexWrap: 'wrap', alignItems: 'center'}}>اینجانب <div style={{display: 'inline-block', width: '200px'}}><Select placeholder={'نام پزشک'} name={'docterId'} className={'fb-20 pad-4'} options={doctors} value={state.fields?.docterId} onChange={this.setField.bind(this, 'docterId')}/></div> پزشک معالج بیمار، مسئولیت درخواست خون اورژانس: <Check label={'بدون کراس مچ'} name={'withoutCrossMatch'} checked={Boolean(state.fields?.withoutCrossMatch)} onChange={this.setField.bind(this, 'withoutCrossMatch')} style={{display: 'inline'}}/> <Check label={'بدون تعیین گروه ABO و Rh'} name={'withoutRH'} checked={Boolean(state.fields?.withoutRH)} onChange={this.setField.bind(this, 'withoutRH')} style={{display: 'inline'}}/> را می پذیرم.</Label>
                                                </ValidationSpot>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={10}>
                                        <Label style={{backgroundColor: '#a1d6ee', padding: '5px 10px'}} className={'flex'}>نام فرآورده مورد نیاز:</Label>
                                        <ValidationSpot ref={this.ref.products} label={'فرآورده‌'} validation={this.validations.products}>
                                            <div className={'dis-f fb-20 pad-4'}>
                                                <Check label={'RBC'} name={'rbcCount'} checked={this.isChecked(state?.fields?.rbcCount)} onChange={this.setField.bind(this, 'rbcCount')}/>
                                                <Input ref={ref.rbcCount} type={'number'} disabled={!this.isChecked(state?.fields?.rbcCount)} className={'fb-3 fb-2x-20'} placeholder={'تعداد'} align={'center'} dir={'ltr'} validation={this.validations.rbcCount} value={state.fields?.rbcCount || ''} onChange={this.setField.bind(this, 'rbcCount')}/>
                                            </div>
                                            <div className={'dis-f fb-20 pad-4'}>
                                                <Check label={'Whole Blood'} name={'wbCount'} checked={this.isChecked(state?.fields?.wbCount)} onChange={this.setField.bind(this, 'wbCount')}/>
                                                <Input ref={ref.wbCount} type={'number'} disabled={!this.isChecked(state?.fields?.wbCount)} className={'fb-3 fb-2x-20'} placeholder={'تعداد'} align={'center'} dir={'ltr'} validation={this.validations.wbCount} value={state.fields?.wbCount || ''} onChange={this.setField.bind(this, 'wbCount')}/>
                                            </div>
                                        </ValidationSpot>
                                    </td>
                                </tr>
                                <tr>
                                    <td colSpan={10} style={{backgroundColor: '#009fda', color: 'white'}}><Label>این فرم در 2 نسخه تکمیل گردد. پس از ارسال هر دو نسخه به بانک خون و ثبت درخواست، نسخه زرد رنگ در بانک خون باقی مانده و نسخه اصلی جهت نگهداری در پرونده، مجددا به بخش ارسال گردد.</Label></td>
                                </tr>
                                </tbody>
                            </table> :
                            <div className={'dis-f'}>
                                <Label className={'fb-20'} size={'medium'}>مشخصات بیمار :</Label>
                                <Input ref={ref.patientFirstName} className={'pad-4 fb-2 fb-5x-4 fb-3x-8 fb-2x-20'} label={'نام'} validation={this.validations.patientFirstName} readOnly={!state.isNewPatient} value={state.fields?.patientFirstName} onChange={this.setField.bind(this, 'patientFirstName')}/>
                                <Input ref={ref.patientLastName} className={'pad-4 fb-4 fb-5x-6 fb-3x-12 fb-2x-20'} label={'نام خانوادگی'} validation={this.validations.patientLastName} readOnly={!state.isNewPatient} value={state.fields?.patientLastName} onChange={this.setField.bind(this, 'patientLastName')}/>
                                <Input ref={ref.patientFatherName} className={'pad-4 fb-3 fb-5x-4 fb-3x-8 fb-2x-20'} label={'نام پدر'} validation={this.validations.patientFatherName} readOnly={!state.isNewPatient} value={state.fields?.patientFatherName} onChange={this.setField.bind(this, 'patientFatherName')}/>
                                <Date ref={ref.patientBirthDate} className={'pad-4 fb-4 fb-5x-6 fb-3x-12 fb-2x-20'} label={'تاریخ تولد'} max={moment()} validation={this.validations.patientBirthDate} readOnly={!state.isNewPatient} value={state.fields?.patientBirthDate} onChange={this.setField.bind(this, 'patientBirthDate')}/>
                                <Input ref={ref.patientNationalCode} align={"center"} direction={"ltr"} className={'pad-4 fb-4 fb-5x-5 fb-3x-10 fb-2x-20'} type={"number"} label={'کدملی'} readOnly={!state.isNewPatient} value={state.fields?.patientNationalCode} onChange={this.setField.bind(this, 'patientNationalCode')}/>
                                <ValidationSpot ref={ref.patientGenderId} label={'جنسیت'} className={'dis-f pad-4 fb-3 fb-5x-5 fb-3x-10 fb-2x-20'} style={{flexDirection: 'column'}} validation={this.validations.patientGenderId} readOnly={!state.isNewPatient}>
                                    <Label size={'small'}>جنسیت</Label>
                                    <div className={'dis-f'}>
                                        <div className={'pad-h-4'}>
                                            <Radio label={'مرد'} name={'patientGenderId'} checked={state.fields?.patientGenderId == 1} onClick={this.setField.bind(this, 'patientGenderId', 1)}/>
                                        </div>
                                        <div className={'pad-h-4'}>
                                            <Radio label={'زن'} name={'patientGenderId'} checked={state.fields?.patientGenderId == 2} onClick={this.setField.bind(this, 'patientGenderId', 2)}/>
                                        </div>
                                    </div>
                                </ValidationSpot>
                                <Select ref={ref.patientProvinceId} className={'pad-4 fb-4 fb-5x-5 fb-3x-10 fb-2x-20'} label={'استان'} options={state.provinces} validation={this.validations.patientProvinceId} readOnly={!state.isNewPatient} value={state.fields?.patientProvinceId} onChange={this.setField.bind(this, 'patientProvinceId')}/>
                                <Select ref={ref.patientCityId} className={'pad-4 fb-4 fb-5x-5 fb-3x-10 fb-2x-20'} label={'شهر'} options={cities} validation={this.validations.patientCityId} readOnly={!state.isNewPatient} value={state.fields?.patientCityId} onChange={this.setField.bind(this, 'patientCityId')}/>
                                <Input className={'pad-4 fb-4 fb-5x-5 fb-3x-10 fb-2x-20'} label={'بیمارستان'} readOnly={true} value={props.user?.hospitalFullName}/>
                                <Select ref={ref.sectionId} className={'pad-4 fb-4 fb-5x-5 fb-3x-10 fb-2x-20'} label={'بخش'} options={state.sections} validation={this.validations.sectionId} value={state.fields?.sectionId} onChange={this.setField.bind(this, 'sectionId')}/>
                                <InputButton ref={ref.patientFileCode} className={'pad-4 fb-4 fb-5x-5 fb-3x-20'} label={'شماره پرونده'} validation={this.validations.patientFileCode} value={state.fields?.patientFileCode} onChange={this.setField.bind(this, 'patientFileCode')} onEnter={this.patientFileCodeSubmitHandler.bind(this)} buttonTitle={'جستجو'} onButtonClick={this.patientFileCodeSubmitHandler.bind(this)}/>
                                {/*<Input ref={ref.patientFileCode} className={'pad-4 fb-4 fb-5x-5 fb-3x-20'} label={'شماره پرونده'} validation={this.validations.patientFileCode} value={state.fields?.patientFileCode} onChange={this.setFiel.bind(this, 'patientFileCode')} onBlur={this.patientFileCodeSubmitHandler.bind(this)} onEnter={this.patientFileCodeSubmitHandler.bind(this)}/>*/}
                                <Separator/>
                                <div className={'fb-6 fb-4x-10 fb-3x-20'}>
                                    <Label className={'flex'}>نمونه خون بیمار :</Label>
                                    <ValidationSpot ref={this.ref.bloodSampleSend} validation={this.validations.bloodSampleSend} label={'نمونه خون بیمار'}>
                                        <div className="dis-f fb-20">
                                            <Radio label={'تهیه و قبل از تزریق ارسال شد.'} name={'bloodSampleSend'} checked={state.fields?.bloodSampleSend === true} onClick={this.setField.bind(this, 'bloodSampleSend', true)}/>
                                        </div>
                                        <div className="dis-f fb-20">
                                            <Radio label={'ارسال نشد.'} name={'bloodSampleSend'} checked={state.fields?.bloodSampleSend === false} onClick={this.setField.bind(this, 'bloodSampleSend', false)}/>
                                        </div>
                                    </ValidationSpot>
                                </div>
                                <Separator className={'dis-n dis-3x-b'}/>
                                <div className={'dis-f fb-7 fb-4x-10 fb-3x-20'}>
                                    <Input ref={this.ref.emergencyRequestReasonStr} type={'text'} name={'emergencyRequestReasonStr'} className={'fb-20 pad-4'} label={'علت درخواست خون اورژانس'} value={state.fields?.emergencyRequestReasonStr} validation={this.validations.emergencyRequestReasonStr} onChange={this.setField.bind(this, 'emergencyRequestReasonStr')}/>
                                    <Input type={'text'} className={'fb-10 pad-4'} direction={'ltr'} align={"center"} readOnly={true} label={'تاریخ درخواست'} value={moment().format('jYYYY-jMM-jDD')}/>
                                    <Input type={'text'} className={'fb-10 pad-4'} direction={'ltr'} align={"center"} readOnly={true} label={'ساعت درخواست'} value={moment().format('HH:mm')}/>
                                </div>
                                <Separator className={'dis-n dis-4x-b'}/>
                                <div className={'fb-7 fb-4x-20'}>
                                    <Label className={'flex'}>مطلع نمودن بانک خون :</Label>
                                    <ValidationSpot ref={this.ref.bloodBankInform} label={'نحوه اطلاع بانک خون'} validation={this.validations.bloodBankInform}>
                                        <div className="dis-f fb-20">
                                            <Radio label={'درخواست تلفنی از بانک خون و سپس تکمیل فرم'} name={'bloodBankInform'} checked={state.fields?.bloodBankInform === false} onClick={this.setField.bind(this, 'bloodBankInform', false)}/>
                                        </div>
                                        <div className="dis-f fb-20">
                                            <Radio label={'تکمیل و ارسال فرم به بانک خون'} name={'bloodBankInform'} checked={state.fields?.bloodBankInform === true} onClick={this.setField.bind(this, 'bloodBankInform', true)}/>
                                        </div>
                                    </ValidationSpot>
                                </div>
                                <Separator/>
                                <div className={'fb-14 fb-4x-20'}>
                                    <Label>زمان نیاز به خون:</Label>
                                    <ValidationSpot ref={this.ref.needCrossMatch} className={'dis-f'} validation={this.validations.needCrossMatch}>
                                        <Radio label={'بلافاصله پس از درخواست پزشک (بدون کراسمچ)'} name={'needCrossMatch'} checked={state.fields?.needCrossMatch === false} onClick={this.setField.bind(this, 'needCrossMatch', false)}/>
                                        <Radio label={'30 دقیقه پس از دریافت درخواست (تعیین ABO، Rh و کراسمچ)'} name={'needCrossMatch'} className={'fb-20'} checked={state.fields?.needCrossMatch} onClick={this.setField.bind(this, 'needCrossMatch', true)}/>
                                    </ValidationSpot>
                                </div>
                                <Separator className={'dis-n dis-4x-b'}/>
                                <div className={'fb-6 fb-4x-10 fb-3x-20'}>
                                    <Label>نام فرآورده مورد نیاز:</Label>
                                    <ValidationSpot ref={this.ref.products} label={'نوع فرآورده'} validation={this.validations.products}>
                                        <div className={'dis-f fb-20 pad-4'}>
                                            <Check label={'RBC'} name={'rbcCount'} className={'flex'} checked={this.isChecked(state.fields?.rbcCount)} onChange={this.setField.bind(this, 'rbcCount')}/>
                                            <Input ref={ref.rbcCount} type={'number'} disabled={!this.isChecked(state.fields?.rbcCount)} className={'fb-5 fb-2x-20'} placeholder={'تعداد'} align={'center'} dir={'ltr'} validation={this.validations.rbcCount} value={state.fields?.rbcCount || ''} onChange={this.setField.bind(this, 'rbcCount')}/>
                                        </div>
                                        <div className={'dis-f fb-20 pad-4'}>
                                            <Check label={'Whole Blood'} name={'wbCount'} className={'flex'} checked={this.isChecked(state.fields?.wbCount)} onChange={this.setField.bind(this, 'wbCount')}/>
                                            <Input ref={ref.wbCount} type={'number'} disabled={!this.isChecked(state.fields?.wbCount)} className={'fb-5 fb-2x-20'} placeholder={'تعداد'} align={'center'} dir={'ltr'} validation={this.validations.wbCount} value={state.fields?.wbCount || ''} onChange={this.setField.bind(this, 'wbCount')}/>
                                        </div>
                                    </ValidationSpot>
                                </div>
                                <Separator/>
                                <ValidationSpot ref={this.ref.docterId} label={'نام پزشک'} validation={this.validations.docterId}>
                                    <Label className={'fb-20'} style={{display: 'flex', flexWrap: 'wrap', alignItems: 'center'}}>اینجانب <div style={{display: 'inline-block', width: '200px'}}><Select placeholder={'نام پزشک'} name={'docterId'} className={'fb-20 pad-4'} options={doctors} value={state.fields?.docterId} onChange={this.setField.bind(this, 'docterId')}/></div> پزشک معالج بیمار، مسئولیت درخواست خون اورژانس: <Check label={'بدون کراس مچ'} name={'withoutCrossMatch'} checked={Boolean(state.fields?.withoutCrossMatch)} onChange={this.setField.bind(this, 'withoutCrossMatch')} style={{display: 'inline'}}/> <Check label={'بدون تعیین گروه ABO و Rh'} name={'withoutRH'} checked={Boolean(state.fields?.withoutRH)} onChange={this.setField.bind(this, 'withoutRH')} style={{display: 'inline'}}/> را می پذیرم.</Label>
                                </ValidationSpot>
                            </div>}
                    </div>
                </ModalContent>
                <ModalControls>
                    <Check className={'mar-4'} label={'نمایش فرم اصلی'} checked={props.base.sectionEmerRequestFormPrintView} onChange={this.formViewChangeHandler.bind(this)}/>
                    <div className="flex"/>
                    {state.action === ModalAction.UPDATE && <React.Fragment>
                        {/*<Button refer={ref.printLabel} className={'mar-4'} theme={'blue'} onClick={this.print.bind(this)}>چاپ برچسب نمونه گیری</Button>*/}
                        <Button refer={ref.update} className={'mar-4'} theme={'yellow'} onClick={this.updateClickHandler.bind(this)}>ویرایش درخواست</Button>
                    </React.Fragment>}
                    {state.action === ModalAction.INSERT && <React.Fragment>
                        <Check className={'mar-4'} label={'چاپ خودکار'} checked={props.base.normRequestFormPrintOnSubmit} onChange={this.requestPrintOnSubmit.bind(this)}/>
                        <Button refer={ref.insert} className={'mar-4'} theme={'blue'} onClick={this.insertClickHandler.bind(this)}>ثبت درخواست</Button>
                    </React.Fragment>}
                    <Button refer={ref.close} className={'mar-4'} onClick={this.close.bind(this)}>بستن</Button>
                </ModalControls>
            </Modal>
            <ModalPrint refer={this.ref.modalPrint}/>
        </React.Fragment>;
    }

    autoFillClickHandler(event) {
        if (event.ctrlKey && event.shiftKey && event.altKey) {
            // const cities = this.state.provinces.find(item => item.id == 1)?.cities||[];

            this.setState({
                fields: {
                    ...this.state.fields,
                    antiBodyHistory: 1,
                    patientBirthDate: moment("1373-01-29", 'jYYYY-jMM-jDD'),
                    bloodSamplingDate: moment(),
                    bloodSamplingTime: "15:20",
                    patientCityId: [{id: 1, text: 'تبریز', forced: true}],
                    complicationsHistory: 1,
                    cppcount: 1,
                    crycount: 1,
                    diseaseCauseId: 7,
                    docterId: null,
                    patientFatherName: "حسین",
                    ffpcount: 1,
                    patientFirstName: "فرشاد",
                    patientGenderId: 1,
                    hemoglobinAmount: "20",
                    howToPrescribe: "آمپول",
                    injectionHistory: 1,
                    injectionVelocity: "---",
                    patientLastName: "محمودی نژاد",
                    lrbcCount: 1,
                    medicationName: "آموکسی سیلین",
                    medicationPrescribeNeed: true,
                    patientNationalCode: "1361399198",
                    needDate: moment().add(5, "jday"),
                    needTime: "12:00",
                    otherProductsCount: 1,
                    otherProductsName: "خون",
                    patientBloodGroupId: [{id: 5}],
                    patientDiagnosticStr: "کیست",
                    patientDiagnosticId: [{id: 1}],
                    patientFileCode: "555555",
                    pediatricCount: 1,
                    pltamount: "20",
                    pltcount: 1,
                    pregnancyHistory: 1,
                    patientProvinceId: [{id: 1, text: 'آ.شرقی', forced: true}],
                    rbcCount: 1,
                    requestPurpose: 1,
                    sampler: true,
                    samplerLastName: "الهی اصل",
                    samplerName: "علی",
                    surgeryTypeId: [{id: 10}],
                    termsAndConditions: true,
                    washedRbccount: 1,
                    washedTime: 1,
                    wbCount: 1,
                }
            }, _ => {
                console.log(this.state.fields);
            });
        }
    }

    close(success) {
        this.ref.modal.current.close();

        if (success === true)
            this.props.onSuccess();

        this.props.onClose();
    }

    fieldWillUpdate(keys, value, currentFields, nextFields) {
        const {ref} = this;

        switch (keys[0]) {
            case 'patientFileCode':
                delete nextFields.patientFirstName;
                delete nextFields.patientLastName;
                delete nextFields.patientFatherName;
                delete nextFields.patientBirthDate;
                delete nextFields.patientNationalCode;
                delete nextFields.patientGenderId;
                delete nextFields.patientProvinceId;
                delete nextFields.patientCityId;
                this.setState({patientFileInfo: undefined});
                break;
            case 'bloodSampleSend':
            case 'bloodBankInform':
            case 'needCrossMatch':
            case 'docterId':
                ref[keys[0]].current.validate(value);
                break;
            case 'patientProvinceId':
                delete nextFields['patientCityId'];
                break;
            case 'rbcCount':
            case 'wbCount':
                if (value === true)
                    value = 1;
                else if (value === false) {
                    ref[keys[0]].current.error(false);
                }
                nextFields[keys[0]] = value;
                ref.products.current.validate(nextFields);
                break;
            default:
        }
    }

    formViewChangeHandler(flag) {
        this.props.updateBase({sectionEmerRequestFormPrintView: flag});
    }

    insertClickHandler() {
        const {ref, state} = this;

        if (this.validate()) {
            ref.insert.current.loading();
            this.setState({error: null});

            SectionEmerRequest.insert({
                patientFirstName: state.fields?.patientFirstName,
                patientLastName: state.fields?.patientLastName,
                patientFatherName: state.fields?.patientFatherName,
                patientBirthDate: state.fields?.patientBirthDate.format('jYYYY-jMM-jDD'),
                patientNationalCode: state.fields?.patientNationalCode?.toString() || null,
                patientGenderId: state.fields?.patientGenderId,
                patientProvinceId: state.fields?.patientProvinceId?.[0]?.id,
                patientCityId: state.fields?.patientCityId?.[0]?.id,
                sectionId: state.fields?.sectionId[0]?.id,
                patientFileCode: state.fields?.patientFileCode,
                patientFileCodeId: state?.patientFileInfo?.patientFileCodeId || null,
                bloodSampleSend: state.fields?.bloodSampleSend,
                emergencyRequestReasonStr: state.fields?.emergencyRequestReasonStr,
                bloodBankInform: state.fields?.bloodBankInform,
                needCrossMatch: state.fields?.needCrossMatch,
                rbcCount: state.fields?.rbcCount || 0,
                wbCount: state.fields?.wbCount || 0,
                docterId: state.fields?.docterId?.[0]?.id,
                withoutCrossMatch: state.fields?.withoutCrossMatch || false,
                withoutRH: state.fields?.withoutRH || false
            }).then(_ => {
                new Notif(Resource.STRING.FETCH.INSERT_SUCCESSFUL).show();
                ref.insert.current.loading(false);
                this.close(true);

                if (this.props.base.normRequestFormPrintOnSubmit)
                    this.print(state.fields);
            }).catch(message => {
                ref.insert.current.loading(false);
                this.setState({error: message});
            });
        }
    }

    isChecked(value) {
        return value !== undefined && value !== false;
    }

    open(data, action) {
        if (action === ModalAction.INSERT) {
            this.setState({
                data,
                action,
                fields: {
                    sectionId: [{id: this.props.user.sectionId}]
                },
                patientFileInfo: undefined,
                isNewPatient: false,
                error: null
            });
        } else if (action === ModalAction.UPDATE || action === ModalAction.VIEW) {
            this.setState({
                data,
                action,
                patientFileInfo: undefined,
                isNewPatient: false,
                error: null,
                loading: 'در حال دریافت اطلاعات درخواست'
            });

            SectionEmerRequest.data({
                sectionRequestId: data.sectionRequestId
            })
                .then(data => {
                    const province = [this.state.provinces.find(item => item.id == data.patientProvinceId) || {}];

                    this.setState({
                        loading: null,
                        patientFileInfo: {
                            patientFileCodeId: data.patientFileCodeId
                        },
                        isNewPatient: false,
                        fields: {
                            ...this.state.fields,
                            patientFirstName: data.patientFirstName,
                            patientLastName: data.patientLastName,
                            patientFatherName: data.patientFatherName,
                            patientBirthDate: data.patientBirthDate ? moment(data.patientBirthDate, 'jYYYY-jMM-jDD') : null,
                            patientNationalCode: data.patientNationalCode,
                            patientGenderId: data.patientGenderId,
                            patientProvinceId: province,
                            patientCityId: [{id: data.patientCityId}],
                            sectionId: [{id: data.sectionId}],
                            patientFileCode: data.patientFileCode,
                            bloodSampleSend: data.bloodSampleSend,
                            emergencyRequestReasonStr: data.emergencyRequestReasonStr,
                            bloodBankInform: data.bloodBankInform,
                            needCrossMatch: data.crossMatch,
                            rbcCount: data.rbcCount || 0,
                            wbCount: data.wbCount || 0,
                            docterId: [{id: data.docterId}],
                            withoutCrossMatch: data.withoutCrossMatch || false,
                            withoutRH: data.withoutRh || false
                        }
                    });
                })
                .catch(message => {
                    new Notif({message, theme: 'error'}).show();

                    this.ref.modal.current.close();
                });
        }

        this.ref.modal.current.open()
            .then(_ => {
                if (action === ModalAction.INSERT) {
                    this.ref.patientFileCode.current.focus();
                }
            });
    }

    patientFileCodeSubmitHandler(value) {
        const {state} = this;

        if (!value) {
            this.setState({patientFileInfo: undefined});
        }

        if (value) {
            this.setState({
                patientFileInfo: undefined,
                isNewPatient: false,
                loading: 'در حال دریافت پرونده بیمار'
            });

            Patient.data({
                patientFileCode: value
            })
                .then(data => {
                    const cities = state.provinces.find(item => item.id == data?.patientProvinceId)?.cities || [];
                    const patient = {
                        patientFirstName: data.patientFirstName,
                        patientLastName: data.patientLastName,
                        patientFatherName: data.patientFatherName,
                        patientBirthDate: moment(data.patientBirthDate, 'jYYYY-jMM-jDD'),
                        patientNationalCode: data.patientNationalCode,
                        patientGenderId: data.patientGenderId,
                        patientProvinceId: data?.patientProvinceId ? [{id: data.patientProvinceId, cities}] : null,
                        patientCityId: data?.patientCityId ? [{id: data.patientCityId}] : null,
                    };

                    this.setState({
                        patientFileInfo: data,
                        isNewPatient: false,
                        fields: {
                            ...state.fields,
                            ...patient
                        },
                        loading: false
                    });
                })
                .catch(message => {
                    this.setState({
                        patientFileInfo: undefined,
                        isNewPatient: true,
                        loading: false,
                    }, _ => {
                        this.ref.patientFirstName.current.focus();
                    });
                    new Notif({message, theme: 'error'}).show();
                });
        }
    }

    print(data = null) {
        this.ref.modalPrint.current.open({
            title: 'چاپ',
            prints: [{
                id: 'sectionNormRequestForm',
                title: 'چاپ فرم درخواست',
                count: 1,
                template: printerTemplate.INSERT_NORM_REQUEST,
                parameters: {
                    PatientFirstName: data?.patientFirstName,
                    PatientLastName: data?.patientLastName,
                    PatientFatherName: data?.patientFatherName,
                    PatientBirthDate: data?.patientBirthDate,
                    PatientNationalCode: data?.patientNationalCode,
                    PatientGenderId: data?.patientGenderId,
                    PatientProvinceStr: data?.patientProvinceId[0]?.text,
                    PatientCityStr: data?.patientCityId[0]?.text,
                    HospitalNameStr: this.props.user?.hospitalFullName || '-',
                    SectionStr: data?.sectionId[0]?.text,
                    PatientFileCode: data?.patientFileCode,
                    BloodSampleSend: data?.bloodSampleSend,
                    EmergencyRequestReasonStr: data?.emergencyRequestReasonStr,
                    BloodBankInform: data?.bloodBankInform,
                    NeedCrossMatch: data?.needCrossMatch,
                    RbcCount: data?.rbcCount,
                    WbCount: data?.wbCount,
                    DocterName: data?.docterName,
                    WithoutCrossMatch: data?.withoutCrossMatch,
                    WithoutRH: data?.withoutRH
                }
                // }, {
                //     id: 'normRequestSamplingLabel',
                //     title: 'چاپ برچسب نمونه گیری',
                //     count: 1,
                //     template: printerTemplate.NORM_REQUEST_SAMPLING_LABEL,
                //     parameters: {
                //         PFullName: `${data?.patientFirstName} ${data?.patientLastName}`,
                //         PFileCodeStr: data?.patientFileCode,
                //         SamplingDateTime: data?.bloodSamplingDate.format('jYYYY/jMM/jDD HH:mm'),
                //         SamplerFullName: `${data?.samplerName} ${data?.samplerLastName}`
                //     }
            }]
        });
    }

    requestPrintOnSubmit(value) {
        this.props.updateBase({normRequestFormPrintOnSubmit: value});
    }

    updateClickHandler() {
        const {ref, state} = this;

        if (this.validate()) {
            ref.update.current.loading();
            this.setState({error: null});

            SectionEmerRequest.update({
                sectionEmgRequestId: state.data?.sectionNormOrEmgRequestId,
                sectionId: state.fields?.sectionId[0]?.id,
                patientFileCodeId: state?.patientFileInfo?.patientFileCodeId || null,
                bloodSampleSend: state.fields?.bloodSampleSend,
                emergencyRequestReasonStr: state.fields?.emergencyRequestReasonStr,
                bloodBankInform: state.fields?.bloodBankInform,
                needCrossMatch: state.fields?.needCrossMatch,
                rbcCount: state.fields?.rbcCount || 0,
                wbCount: state.fields?.wbCount || 0,
                docterId: state.fields?.docterId?.[0]?.id,
                withoutCrossMatch: state.fields?.withoutCrossMatch || false,
                withoutRH: state.fields?.withoutRH || false
            }).then(_ => {
                new Notif(Resource.STRING.FETCH.UPDATE_SUCCESSFUL).show();
                ref.update.current.loading(false);

                this.close(true);
            }).catch(message => {
                ref.update.current.loading(false);
                this.setState({error: message});
            });
        }
    }

    validate() {
        const {state, ref} = this;
        const validate = Tool.validate(ref.patientFirstName,
            ref.patientLastName,
            ref.patientFatherName,
            ref.patientBirthDate,
            ref.patientNationalCode,
            [ref.patientGenderId, state.fields?.patientGenderId],
            ref.patientProvinceId,
            ref.patientCityId,
            ref.sectionId,
            ref.patientFileCode,
            [ref.bloodSampleSend, state.fields?.bloodSampleSend],
            ref.emergencyRequestReasonStr,
            [ref.bloodBankInform, state.fields?.bloodBankInform],
            [ref.needCrossMatch, state.fields?.needCrossMatch],
            [ref.docterId, state.fields?.docterId],
            // ref.withoutCrossMatch,
            // ref.withoutRH,
            [ref.products, state.fields],
            ref.rbcCount,
            ref.wbCount
        );

        if (validate !== true)
            new Notif({message: validate.message, theme: 'error'}).show();

        return validate === true;
    }
}

const mapStateToProps = state => {
    return {
        base: state.base,
        user: state.user
    };
};

const mapDispatchToProps = dispatch => {
    return {
        updateBase: props => dispatch(updateBase(props))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalEmerRequest);